import { createElement } from '../../adapters/dom';
import { copyToClipboard } from '../../adapters/clipboard';

export interface CreateCopyButtonOptions {
  value: string;
  label?: string;
  successLabel?: string;
  errorLabel?: string;
  className?: string;
}

export function createCopyButton(options: CreateCopyButtonOptions): HTMLButtonElement {
  const label = options.label ?? 'Копировать';
  const successLabel = options.successLabel ?? 'Скопировано';
  const errorLabel = options.errorLabel ?? 'Ошибка';

  const button = createElement('button', {
    className: options.className ?? 'cpw-copy-button',
    attributes: {
      type: 'button',
      title: label,
      'aria-label': label
    }
  }) as HTMLButtonElement;

  const icon = createElement('span', {
    className: 'cpw-copy-button-icon',
    textContent: '⧉'
  });

  const text = createElement('span', {
    className: 'cpw-copy-button-text',
    textContent: label
  });

  button.append(icon, text);

  let resetTimer: number | null = null;

  const setButtonState = (stateIcon: string, stateText: string): void => {
    icon.textContent = stateIcon;
    text.textContent = stateText;
  };

  button.addEventListener('click', async () => {
    const ok = await copyToClipboard(options.value);

    setButtonState(ok ? '✓' : '!', ok ? successLabel : errorLabel);

    if (resetTimer !== null) {
      window.clearTimeout(resetTimer);
    }

    resetTimer = window.setTimeout(() => {
      setButtonState('⧉', label);
      resetTimer = null;
    }, 1500);
  });

  return button;
}